<header class="flex header">
  <h2>
    {{
      representative?.id
        ? ('Representative_Detail_Modal_Title_Edit' | translateWF: 'Edit Representative')
        : ('Representative_Detail_Modal_Title_Add' | translateWF: 'Add Representative')
    }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <form [formGroup]="representativeForm">
    <!-- First Name -->
    <div class="form-box">
      <label for="firstName" ariaRequired="true">{{ 'Representative_Detail_Modal_FirstName' | translateWF: 'First Name' }}</label>
      <input pInputText type="text" id="firstName" formControlName="firstName" class="w-full" />
    </div>
    <!-- Last Name -->
    <div class="form-box">
      <label for="lastName" ariaRequired="true">{{ 'Representative_Detail_Modal_LastName' | translateWF: 'Last Name' }}</label>
      <input pInputText type="text" id="lastName" formControlName="lastName" class="w-full" />
    </div>
    <!-- Phone Number -->
    <div class="form-box">
      <label for="phoneNumber" ariaRequired="true">{{ 'Representative_Detail_Modal_PhoneNumber' | translateWF: 'Phone Number' }}</label>
      <input pInputText type="text" id="phoneNumber" formControlName="phoneNumber" class="w-full" />
    </div>
    <!-- Email -->
    <div class="form-box">
      <label for="email" ariaRequired="true">{{ 'Representative_Detail_Modal_Email' | translateWF: 'Email' }}</label>
      <input pInputText type="email" id="email" formControlName="email" class="w-full" />
    </div>
  </form>
</section>

<footer>
  <p-button class="w-full" [label]="'Save' | translate" [disabled]="representativeForm.invalid" (click)="onSave()" />
  <p-button class="w-full" [label]="'Cancel' | translate" variant="outlined" (click)="onClose()" />
</footer>
